<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">线路站台管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%;"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="线路名称" prop="LineId">
                <el-select
                  v-model="data.LineId"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in LineArr"
                    :key="item.ID"
                    :label="item.LineName"
                    :value="item.ID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="站台名称" prop="StationId">
                <el-select
                  v-model="data.StationId"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in StationArr"
                    :key="item.Id"
                    :label="item.StationName"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="线路方向" prop="Direction">
                <el-select
                  v-model="data.Direction"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in DirectionArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="站点序号" prop="StationIndex">
                <el-input
                  v-model="data.StationIndex"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Description">
                <el-input
                  v-model="data.Description"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "LineStationManagerInfo",
  controller: "UI",
  action: "LineStationManagerInfo",
  data() {
    return {
      data: {
        LineId: "",
        StationId: "",
        Direction: "",
      },
      LineArr: [],
      StationArr: [],
      DirectionArr: [
        { value: "单行", label: "单行" },
        { value: "上行", label: "上行" },
        { value: "下行", label: "下行" },
      ],
      IsEdit: false,
      rules: {
        LineId: [
          { required: true, message: "请选择线路名称", trigger: "change" },
        ],
        StationId: [
          { required: true, message: "请选择站台名称", trigger: "change" },
        ],
        Direction: [
          { required: true, message: "请选择线路方向", trigger: "change" },
        ],
        StationIndex: [
          {
            required: false,
            message: "站点序号必须为整数",
            trigger: "blur",
            pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,
          },
        ],
      },
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    this.getLines();
    this.getStations();
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          ID: InfoId,
        };
        new MyApis.LineStationRelationApi()
          .GeItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //绑定线路类型
    getLines() {
      const SearchInfo = {
        Validity: "1",
      };
      new MyApis.LinesApi()
        .GetItemPagingList(SearchInfo)
        .then((r) => {
          r = r.data.Data;
          this.LineArr = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //绑定站台类型
    getStations() {
      const SearchInfo = {
        Validity: "1",
      };
      new MyApis.StationsApi()
        .GetItemPagingList(SearchInfo)
        .then((r) => {
          r = r.data.Data;
          this.StationArr = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      const that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.GetLineStations(function(data) {
            if (!data) {
              that.saveData();
            }
          });
        } else {
          return false;
        }
      });
    },
    //检验是否有重复记录
    GetLineStations(callback) {
      let searchInfo = {
        PageSize: 100000000,
      };
      let isExistEntity = false;
      new MyApis.LineStationRelationApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          const result = r.PageContents;
          if (result != null) {
            if (this.$route.query.type == "edit") {
              const index = result.findIndex(
                (p) =>
                  p.LineId == this.data.LineId &&
                  p.StationId == this.data.StationId &&
                  p.ID != this.data.ID
              );
              if (index > -1) {
                this.$message.error("该线路下已存在该站台，请重新输入！");
                isExistEntity = true;
              }
            } else {
              const index = result.findIndex(
                (p) =>
                  p.LineId == this.data.LineId &&
                  p.StationId == this.data.StationId
              );
              if (index > -1) {
                this.$message.error("该线路下已存在该站台，请重新输入！");
                isExistEntity = true;
              }
            }
          }
          callback(isExistEntity);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.LineStationRelationApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "线路站台修改";
            this.logInfo.LogMessage = r ? "线路站台修改成功" : "线路站台修改失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "线路站台管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          Id: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.LineStationRelationApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "线路站台添加";
            this.logInfo.LogMessage = r ? "线路站台添加成功" : "线路站台添加失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "线路站台管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
